import React, { useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';

const ScreeningTabs = ({ screeningData }) => {
  const [activeTab, setActiveTab] = useState('Pre-screening questions');
  const tabs = ['Pre-screening questions'];

  return (
    <div className="bg-white p-5 rounded-2xl shadow-style mt-4 h-[95%]">
      <div className="flex items-center border-b border-gray-200">
        {tabs.map(tab => (
          <button key={tab} onClick={() => setActiveTab(tab)} className={`py-1 px-4 text-sm font-semibold relative ${activeTab === tab ? 'mph-primary' : 'text-gray-500'}`}>
            {tab} {activeTab === tab && <div className="absolute bottom-0 left-0 w-full h-0.5 mph-primary-bg rounded-full"></div>}
          </button>
        ))}
      </div>
      <div className="pt-4">
        {activeTab === 'Pre-screening questions' && (
          <ul className="space-y-3 text-xs text-gray-333">
            {Array.isArray(screeningData?.questions) && screeningData.questions.length > 0 ? (
              screeningData.questions.map((q, i) => (
                <li key={i} className="flex items-start gap-2">
                  <FiChevronRight className="mph-primary mt-1 flex-shrink-0" />
                  {q}
                </li>
              ))
            ) : (
              <li className="text-gray-500">No pre-screening questions found.</li>
            )}
          </ul>
        )}
        {activeTab === 'Gaps From Job Description' && (
          <ul className="space-y-3 text-xs text-gray-333">
            {Array.isArray(screeningData?.resume_gap_reason) && screeningData.resume_gap_reason.length > 0 ? (
              screeningData.resume_gap_reason.map((gap, i) => (
                <li key={i} className="flex items-start gap-2">
                  <FiChevronRight className="mph-primary mt-1 flex-shrink-0" />
                  {gap}
                </li>
              ))
            ) : (
              <li className="text-gray-500">No gaps from job description found.</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};
export default ScreeningTabs;